import { DefaultModalComponent } from '@hutsix/ngxh6';

export const custom_modals: { [key: string]: any } = {
  DefaultModalComponent: DefaultModalComponent,
};
